module.exports = __webpack_public_path__ + "media/images/Go-up-arow_2Go-up-arow-1c199aaa81bb29ea0121f9b51dbe9a0f.png";